// appearance.js — Abschnitt „Erscheinungsbild“: Modus, Kontrast, Leitfarbe (Dynamic Color), Bewegung.
// Speichert lokal sofort (kein Aufblitzen beim nächsten Laden) und — falls angemeldet — in preferences.theme.
import { html, render } from '../core/h.js';
import { on } from '../core/dom.js';
import { theme, setTheme } from '../theme/theme.js';
import { SEED_PRESETS, DEFAULT_SEED } from '../theme/presets.js';
import { api } from '../../shared/api.js';
import { t } from '../../shared/i18n.js';

const T = (k) => t('ui.' + k);

export function appearanceSection(container, { save = true } = {}) {
  const draw = () => {
    const t = theme.value;
    const seed = t.seed || DEFAULT_SEED;
    render(container, html`
      <div class="vc-appearance">
        <div class="vc-appearance-row">
          <span class="t-title-s">${T('mode')}</span>
          <div class="vc-btn-group is-connected" role="group" aria-label="${T('mode')}">
            ${[['system', T('mode_system'), 'brightness_auto'], ['light', T('mode_light'), 'light_mode'], ['dark', T('mode_dark'), 'dark_mode']].map(([v, l, i]) =>
              html`<button type="button" class="vc-btn is-tonal" data-set-mode="${v}" aria-pressed="${(t.mode || 'system') === v}"><span class="vc-icon" aria-hidden="true">${i}</span>${l}</button>`)}
          </div>
        </div>
        <div class="vc-appearance-row">
          <span class="t-title-s">${T('color')}</span>
          <div class="vc-swatches" role="radiogroup" aria-label="${T('color')}">
            ${SEED_PRESETS.map((p, i) => {
              const val = i === 0 ? '' : p.hex;
              const active = (t.seed || '') === val;
              return html`<button type="button" role="radio" class="vc-swatch" data-set-seed="${val}" aria-checked="${active}" style="--sw:${p.hex}" aria-label="${T('color_' + p.id)}" title="${T('color_' + p.id)}">
                ${active ? html`<span class="vc-icon" aria-hidden="true">check</span>` : ''}</button>`;
            })}
            <label class="vc-swatch is-custom" title="${T('color_custom')}">
              <span class="vc-icon" aria-hidden="true">colorize</span><span class="vc-visually-hidden">${T('color_custom')}</span>
              <input type="color" data-set-seed-custom value="${seed}">
            </label>
          </div>
        </div>
        <div class="vc-appearance-row">
          <span class="t-title-s">${T('contrast')}</span>
          <div class="vc-btn-group is-connected" role="group" aria-label="${T('contrast')}">
            ${[['standard', T('contrast_standard')], ['medium', T('contrast_medium')], ['high', T('contrast_high')]].map(([v, l]) =>
              html`<button type="button" class="vc-btn is-outlined" data-set-contrast="${v}" aria-pressed="${(t.contrast || 'standard') === v}">${l}</button>`)}
          </div>
        </div>
        <label class="vc-choice">
          <span class="vc-choice-text"><span class="t-body-l">${T('motion_reduce')}</span>
            <small>${T('motion_reduce_hint')}</small></span>
          <input type="checkbox" role="switch" class="vc-switch" data-set-motion ${t.motion === 'reduced' ? 'checked' : ''}>
        </label>
      </div>`);
  };
  let timer = null;
  const persist = (next) => {
    if (!save) return;
    clearTimeout(timer);
    timer = setTimeout(() => api.put('/api/me', { preferences: { theme: { seed: next.seed || null, mode: next.mode, contrast: next.contrast, motion: next.motion } } }), 400);
  };
  const apply = (patch) => setTheme(patch, { onSave: persist }).then(draw);
  const offs = [
    on(container, 'click', '[data-set-mode]', (e, b) => apply({ mode: b.dataset.setMode })),
    on(container, 'click', '[data-set-contrast]', (e, b) => apply({ contrast: b.dataset.setContrast })),
    on(container, 'click', '[data-set-seed]', (e, b) => apply({ seed: b.dataset.setSeed || null })),
    on(container, 'change', '[data-set-seed-custom]', (e, i) => apply({ seed: i.value })),
    on(container, 'change', '[data-set-motion]', (e, i) => apply({ motion: i.checked ? 'reduced' : 'system' })),
  ];
  draw();
  return () => offs.forEach((f) => f());
}
